// public/foil-utils.js
// Utilities for handling different foil types with masks

/**
 * CSS class names for different foil mask types
 */
export const FOIL_CLASSES = {
  OLD_BORDER: 'foil-type-old-border',
  OLD_BORDER_GREEN: 'foil-type-old-border-green',
  OLD_BORDER_BLACK: 'foil-type-old-border-black',
};

/**
 * Helper function to determine foil type based on card frame and colors
 * Returns a CSS class name from FOIL_CLASSES or null for standard foil
 *
 * @param {Object} cardData - The card data object
 * @returns {string|null} - CSS class name or null
 */
export function getFoilTypeClass(cardData) {
  if (!cardData?.frame) {
    return null;
  }

  // Old border frames (1993 and 1997) - only the frame is foil
  const isOldBorder = cardData.frame === '1993' || cardData.frame === '1997';
  if (isOldBorder) {
    // Check for color-specific masks
    const colors = cardData.colors || [];

    // Green cards (mono-green only)
    if (colors.length === 1 && colors[0] === 'G') {
      return FOIL_CLASSES.OLD_BORDER_GREEN;
    }

    // Black cards (mono-black only)
    if (colors.length === 1 && colors[0] === 'B') {
      return FOIL_CLASSES.OLD_BORDER_BLACK;
    }

    // Default old border for all other colors/combinations
    return FOIL_CLASSES.OLD_BORDER;
  }

  // Modern and future frames use full-card foil (no mask needed)
  return null;
}
